<div class="copy-tooltip">
    @if (isCopySuccess()) {
        <div class="copy-tooltip_success-copy" (click)="onCopyClick($event)">
            <svg class="copy-tooltip_success-copy-icon">
                <use xlink:href="#approve"></use>
            </svg>
            <span>{{'components.copy.copy_success_short' | l10n}}</span>
        </div>
    } @else {
        <div class="copy-tooltip_copy" (click)="onCopyClick($event)">
            <svg class="copy-tooltip_copy-icon">
                <use xlink:href="#copy"></use>
            </svg>
        </div>
        @if (link) {
            <div class="copy-tooltip_divider"></div>
            <a class="copy-tooltip_explore" [href]="link" target="_blank" rel="noopener noreferrer">
                <svg class="copy-tooltip_explore-icon">
                    <use xlink:href="#search"></use>
                </svg>
            </a>
        }
    }
</div>
